<template>
  <div id="app">
    <div v-if="$route.meta.show" style="z-index: -1;position:fixed;width:100%;height:100%;background-color:#f1f1f1;"></div>
    <Top v-if="$route.meta.show" :act='act'></Top>
    
    <router-view :act='act' :act2='act2' :act3='act3'>
    </router-view>
    <Bottom v-if="$route.meta.show"></Bottom>
    <div v-if="$route.meta.show" class="fix-box" >
          
      <ul class="el-list2" style="transition:0.2s;">
          <li class="el-items" @mouseover="toolshow = true" @mouseout="toolshow = false">
            <i class="el-icon-phone-outline"></i><br/>
            客服
            <div class="tooltip" v-show="toolshow">
              <div style="background-color:#fff;padding: 10px;border-radius: 10px;border:1px solid #eee">
                <div style="color:#666;font-size:14px;text-align: center;margin-bottom: 10px;">9:00-18:00</div>
                <el-link v-for="(item,index ) in qq" :key="index" :href="'tencent://message/?uin='+item+'&Site=www.mmicw.com&Menu=yes%22'" style="margin-bottom:10px;" :underline="false">
                  <img src="@/assets/button_old_161.gif" />
                </el-link>
                <div class="popper_arrow"></div>
              </div>
              
            </div>
          </li>
          <li class="el-items" @click="goshopcar">
            <i class="el-icon-shopping-cart-2"></i><br/>
            购物车
          </li>
          <li class="el-items" @click="backtop">
            <i class="el-icon-arrow-up"  style="font-size:20px;"></i><br/>
            顶部
          </li>

        </ul>
    </div>
  </div>
</template>

<script>
import Top from './components/Top.vue';
import Bottom from './components/Bottom.vue';
import {index} from './api';

export default {
  name: 'App',
  data(){
    return {
      act:false,
      act2:false,
      act3:false,
      toolshow:false,
      toolshow2:false,
      qq:[],
    }
  },

  methods:{
    lscroll(){
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop > 550){
            this.act = true;
        } else {
            this.act = false;
        }

        if(scrollTop >= 1320){
            this.act3 = true;
        } else {
            this.act3 = false;
        }

    },
    backtop(){
      window.scroll(0,0)
    },
    goshopcar(){
      this.$router.push('/bom')
    },
  },
  created(){
    index({comp:'qq'}).then(res=>{
      this.qq = res;
      
    })
    
  },
  mounted(){
    window.onscroll = this.lscroll;
    this.$store.dispatch('getCategoryList');
    
  },
  components: {
    Top,
    Bottom
  }
}
</script>

<style>
.tooltip a{
  margin:0px;
}
.tooltip{
  position:absolute;right:63px;top:20px;width:100px;
  border-radius: 20px;
  padding-right: 10px;
  
}
  .popper_arrow{
        width: 0px;
				height: 0px;
        border-left: 10px solid #fff;
				border-top:5px solid transparent;
				border-bottom:5px solid transparent;	
        position: absolute;
        top: 15px;
        right: 0px;
  }
  .el-tooltip__popper a{
    margin:0px;
  }

  .el-tooltip__popper.is-light{
    border-color: #666;
  }
.el-list2{
  text-align:center;display:flex;
  justify-content:center;flex-direction: column;
  border:1px solid #ddd;
  background-color:white;
  border-radius: 50px;
  overflow: hidden;
}
.el-items{
  padding:10px;font-size: 14px;
  transition: 0.2s;
  cursor: pointer;
}
.el-items i{
  font-size:20px;
}
.el-items:hover{
  background: rgb(5, 124, 195);
  color: white;
}



.fix-box{
  width: auto;
  position: fixed;
  z-index: 999;
  right: 5px;
  top: 250px;

}

.amoudle{
  width:1190px;margin:0 auto;
  height: auto;
  display: flex;
  margin-bottom: 20px;
  position:relative;
}

*{
  padding: 0px;
  margin: 0px;
}

ul li{
  list-style: none;
}
@media screen and (max-width:1200px) {
  .fix-box{
    display: none;
  }
  .el-list{
    display: none;
  }
}


</style>
